import { render, staticRenderFns } from "./UserPinForm.vue?vue&type=template&id=fbc73068&scoped=true&"
import script from "./UserPinForm.vue?vue&type=script&lang=js&"
export * from "./UserPinForm.vue?vue&type=script&lang=js&"
import style0 from "./UserPinForm.vue?vue&type=style&index=0&id=fbc73068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc73068",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserAvatar: require('/usr/src/nuxt-app/components/User/UserAvatar.vue').default,KeyPin: require('/usr/src/nuxt-app/components/KeyPin.vue').default})
